import React from 'react';
import AppointmentStatusBadge from './AppointmentStatusBadge';
import ChatButton from '../../buttons/Chat_button.svg';
import { getPatientVisiblePractices } from '../utils/patientPracticeUtils';

const PatientAppointmentPracticesTable = ({ 
    selectedAppointment, 
    onPracticeChat 
}) => {
    const visiblePractices = getPatientVisiblePractices(selectedAppointment);
    if (visiblePractices.length === 0) {
        return null;
    }

    const renderChatButton = (practice) => {
        return (
            <button
                type="button"
                onClick={() => onPracticeChat(selectedAppointment, practice)}
                className="inline-flex items-center justify-center w-8 h-8 rounded-md hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                title="Chat"
            >
                <img src={ChatButton} className='w-6 h-6' alt='Chat' />
            </button>
        );
    };

    return (
        <div className="mt-6">
            {/* Table Header */}
            <div className="grid grid-cols-3 gap-4 px-4 py-2 bg-gray-50 border-b border-gray-200">
                <div className="font-inter font-semibold text-sm text-gray-700">
                    Clinic
                </div>
                <div className="font-inter font-semibold text-sm text-gray-700">
                    Status
                </div>
                <div className="font-inter font-semibold text-sm text-gray-700">
                    Actions
                </div>
            </div>
            
            {/* Table Rows */}
            <div className="divide-y divide-gray-100">
                {visiblePractices.map((practice, index) => (
                    <div key={index} className="grid grid-cols-3 gap-4 px-4 py-3 hover:bg-gray-50 transition-colors">
                        {/* Clinic - Location name */}
                        <div className="font-inter font-normal text-[16px] leading-[20px] tracking-normal text-[#2C2C2C]">
                            {practice.location_name}
                        </div>
                        
                        {/* Status - Same badge style as main row */}
                        <div className="font-inter font-normal text-[16px] leading-[20px] tracking-normal text-[#2C2C2C]">
                            <AppointmentStatusBadge status={practice.practice_appointment_status} />
                        </div>
                        
                        {/* Actions - Chat button */}
                        <div className="font-inter font-normal text-[16px] leading-[20px] tracking-normal text-[#2C2C2C]">
                            <div className="flex items-center gap-2">
                                {renderChatButton(practice)}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PatientAppointmentPracticesTable;
